import { render } from "./proposal-settings.vue?vue&type=template&id=217c147b"
import script from "./proposal-settings.vue?vue&type=script&lang=js"
export * from "./proposal-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__